export default __webpack_public_path__ + "static/media/AdobeStock_213435822.2e6a5d91.jpg";